import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { useTooltipFootnoteStore } from "../../../../../../stores/use-tooltip-footnote-store";
import ColorPicker from "../../../../../../components/ui/color-picker/ColorPicker";
import TextArea from "../../../../../../components/ui/input/text-area/TextArea";

function TooltipFootnoteSettings() {
  const { t } = useTranslation();

  const { data, setData } = useTooltipFootnoteStore();

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
        <OptionContainer alignItems="flex-start">
          <OptionLabel>{t("description")}</OptionLabel>
          <OptionContent>
            <TextArea
              placeholder="Add..."
              value={data.description}
              onChange={({ target: { value } }) =>
                setData({ description: value })
              }
              disableNewLine
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel alignToTop>{t("color")}</OptionLabel>
          <OptionContent>
            <ColorPicker
              value={{
                accent: data.color,
                text: data.textColor,
              }}
              hideColorTiles={data.macroType === "footnote"}
              onChange={({ accent, text }) =>
                setData({ color: accent, textColor: text })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default TooltipFootnoteSettings;
